// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isWeekend as fn } from "../isWeekend.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isWeekendWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isWeekendWithOptions;
